<vectronic-input-filter-with-header
  [title]="title()"
  [filterValue]="value()"
  (filterValueChange)="valueChange.emit($event)"
  [stringToFilterConverter]="options()"
  [placeholder]="placeholder()"
  [titleTooltip]="tooltip()"
></vectronic-input-filter-with-header>
